module.exports = __webpack_public_path__ + "static/media/background.4cfe7f55.svg";